import React, { useMemo } from 'react';
import { Package } from 'lucide-react';

const BoxDisplay = ({ questions, styling }) => {
  const boxCounts = useMemo(() => {
    const counts = { 1: 0, 2: 0, 3: 0, 4: 0 };
    questions.forEach(q => {
      if (q.box >= 1 && q.box <= 4) {
        counts[q.box]++;
      }
    });
    return counts;
  }, [questions]);

  const boxes = [
    { number: 1, label: 'Box A', color: 'bg-red-500', description: 'New/Review' },
    { number: 2, label: 'Box B', color: 'bg-yellow-500', description: 'Learning' },
    { number: 3, label: 'Box C', color: 'bg-blue-500', description: 'Familiar' },
    { number: 4, label: 'Mastered', color: 'bg-green-500', description: 'Mastered' }
  ];

  return (
    <div className="p-6 rounded-lg shadow-xl"
      style={{ backgroundColor: styling.headerColor }}
    >
      <h2 className="text-xl font-bold mb-4 text-indigo-400 flex items-center gap-2">
        <Package className="h-5 w-5" />
        Question Distribution
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {boxes.map(box => (
          <div key={box.number} className="bg-slate-700 rounded-lg p-4 border-2 border-slate-600 hover:border-slate-500 transition-colors">
            <div className="flex items-center gap-2 mb-2">
              <div className={`w-3 h-3 rounded-full ${box.color}`} />
              <h3 className="font-semibold text-slate-200 text-sm">{box.label}</h3>
            </div>
            <div className="text-3xl font-bold text-white mb-1">
              {boxCounts[box.number]}
            </div>
            <p className="text-xs text-slate-400">{box.description}</p>
          </div>
        ))}
      </div>
      <div className="mt-4 text-sm text-slate-400 bg-slate-700 p-3 rounded">
        <p className="font-medium text-slate-300 mb-1">Study Schedule:</p>
        <ul className="space-y-1 text-xs">
          <li>• <span className="text-red-400">Box A</span>: Every day</li>
          <li>• <span className="text-yellow-400">Box B</span>: Tuesday, Thursday</li>
          <li>• <span className="text-blue-400">Box C</span>: Friday only</li>
          <li>• <span className="text-green-400">Mastered</span>: No longer appears in sessions</li>
        </ul>
      </div>
    </div>
  );
};

export default BoxDisplay;